import React, {useEffect, useState} from 'react';
import DisposeTableItem from "../../../base/dispose-tab-item";


interface IComponentProps { 
  data?: any;
}
const CarProdName: React.FC<IComponentProps> = (props) => {
  const data = props.data;
  const [ dataList, setDataList ] = useState<any[]>([])

  useEffect(() => {
    const { veh_brand_name, veh_series_name,veh_model_name  } = data
    const list = [
      {
        text: veh_brand_name
      },
      {
        text: veh_series_name
      },
      {
        text: veh_model_name
      },
    ]
    setDataList(list)
  }, [data]);

  return (
    <>
      <DisposeTableItem dataList={dataList}></DisposeTableItem>
    </>
  );
};

export default CarProdName;
